import { render, staticRenderFns } from "./CancellationIndex.vue?vue&type=template&id=7874300a&"
import script from "./CancellationIndex.vue?vue&type=script&lang=js&"
export * from "./CancellationIndex.vue?vue&type=script&lang=js&"
import style0 from "./CancellationIndex.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports